<template>
  <div class="shadow">
    <VueSlickCarousel v-bind="settings" v-if="posts.length > 0">
      <div class="home-slider" v-for="post in posts" :key="post.id">
        <a :href="post.acf.afuslider_url">
          <img v-if="post._embedded['wp:featuredmedia']" :src="post._embedded['wp:featuredmedia'][0].source_url">
        </a>
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
  import axios from "axios";
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

  export default {
    name: 'HomeSlider',
    components: { VueSlickCarousel },
    data() {
     return {
       settings: {
        "dots": true,
        "arrows": true,
        "autoplay": true,
        "dotsClass": "slick-dots custom-dot-class",
        "edgeFriction": 0.35,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "autoplaySpeed": 5000,
        "cssEase": "linear",
       },

        postsUrl: "https://foto-urbana.credopop.com/wp-json/wp/v2/afu-slider?order=asc",
        queryOptions: {
          per_page: 5, // Only retrieve the 10 most recent blog posts.
          page: 1, // Current page of the collection.
          _embed: true //Response should include embedded resources.
        },
        // Returned Posts in an Array
        posts: []
      };
    },
    methods: {
      // Get Recent Posts From WordPress Site
      getRecentMessages() {
        axios
          .get(this.postsUrl, { params: this.queryOptions })
          .then(response => {
            this.posts = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      },
    },
    mounted() {
      this.getRecentMessages();
    }
  }

</script>
<style>
  .shadow:hover {
    box-shadow: 0px 0px 60px 1px rgba(131,128,122,0.39);
    transition: all 0.3s ease-in-out;
    z-index: 1;
  }
  .slick-dots {
    width: 100%;
    position: absolute;
    bottom: 20px;
    display: flex;
    justify-content: center;
  }
  .slick-dots li {
    margin: 0 3px;
  }
  .slick-dots li button:before {
    font-size: 18px;
    line-height: 35px;
  }
  .slick-dots li button:hover,
  .slick-dots li button:focus,
  .slick-dots li.slick-active button:before {
    color: #F4CC0B;
  }
  .slick-arrow,
  .slick-prev,
  .slick-next {
      z-index: 100!important;
  }
  .slick-prev {
    left: 20px;
  }
  .slick-next {
    right: 20px;
  }
  .slick-prev:before, .slick-next:before {
    color: rgba(0,0,0,0.25);
  }
  .home-slider img {
    width: 100%;
    height: 480px;
    object-fit: contain;
  }
  @media only screen and (max-width:1255px){
      .img-aliados{
          height: 120px;
          padding: 10px;
      }
  }


  @media only screen and (max-width: 1150px){

      .menu{
          display: none;
      }
      .res-menu{
          display: inline !important;
          font-size: 30px;
          padding-top: 10px;
          cursor: pointer;
      }

  }

  @media only screen and (max-width: 640px){

      .logo-text {
          width: 62px;
          font-family: Raleway;
          font-style: normal;
          font-weight: bold;
          font-size: 10px;
          line-height: 11px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding-left: 9px;
          padding-top: 11px;
      }

      .search {
          width: 160px;
      }

      .title-about{
          width: 100%;
          font-size: 25px;
      }

      .about-afu{
          width: 100%;
          height: 380px;
      }
      .card-post{
          height: auto;
      }
      .img-gradient, .card-post-img-2{
          height: 180px;
      }


      .yellow{
          width: 100% !important;
      }
      .home-slider img {
          width: 100%;
          height: auto;
      }
      .slideshow-container {
          height: auto !important;
      }
      .img-aliados{
          height: 90px;
          padding: 1px;
      }
      .footer-container{
          padding-left: 40px;
          flex-direction: column;
      }
      footer{
          height: auto;
      }
  }
</style>
